module.exports = __webpack_public_path__ + "static/media/sprintOrganizer.f06ac0d6.svg";